import { tenderAIAPi } from './tender-ai-api';
import { convertModelToFormDataWithFileData } from './helpers';
const createKnowledgeBase = (knowledgeBase) => {
    const formData = convertModelToFormDataWithFileData(knowledgeBase);
    return tenderAIAPi.postForm(`knowledgebase/`, formData);
};
const getKnowledgeBases = (companyId) => {
    const url = companyId && companyId !== 'ALL' ? `knowledgebase/company/${companyId}` : 'knowledgebase/';
    console.log('Knowledge Base API Request URL:', url, 'CompanyId:', companyId);
    return tenderAIAPi.get(url);
};
const getKnowledgeBaseById = (id) => {
    return tenderAIAPi.get(`knowledgebase/${id}`);
};
const updateKnowledgeBase = (id, updateData) => {
    const formData = convertModelToFormDataWithFileData(updateData);
    return tenderAIAPi.putForm(`knowledgebase/${id}`, formData);
};
const deleteKnowledgeBase = (id) => {
    return tenderAIAPi.delete(`knowledgebase/${id}`);
};
const downloadKnowledgeBaseDocument = (folderName, filename) => {
    return tenderAIAPi.get(`document/${folderName}/${filename}`);
};
const KnowledgeBaseApi = {
    createKnowledgeBase,
    getKnowledgeBases,
    getKnowledgeBaseById,
    updateKnowledgeBase,
    deleteKnowledgeBase,
    downloadKnowledgeBaseDocument
};
export default KnowledgeBaseApi;
